import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/storage";
import "firebase/compat/functions";
import "firebase/compat/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyCMoJB9QYsfQ4yj5jomlKiHtQRZokdmvd4",
  authDomain: "smsenergetics.firebaseapp.com",
  databaseURL: "https://smsenergetics.firebaseio.com",
  projectId: "smsenergetics",
  storageBucket: "smsenergetics.appspot.com",
  messagingSenderId: "604546851554",
  appId: "1:604546851554:web:717ef2083f8281fef8b4bb",
  measurementId: "G-EPCV9X72BY",
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

export const auth = firebase.auth();
export const db = firebase.firestore();
export const storage = firebase.storage();
export const functions = firebase.functions();

if (process.env.NODE_ENV === "production") {
  firebase.analytics();
}

export default firebase;
